function initStickyHeader () {

	const globals = {
		stickyWrapperHeight: 0
	};

	const ui = {
		backToTopBtn: document.querySelector('.backToTop')
	};

	const events = {
		backToTop: (e) => {

			e.preventDefault();
			$('html, body').animate({ scrollTop: 0 }, 'slow');

		}
	};

	function init () {

		const { backToTopBtn } = ui;
		const $stickyWrapper = $('#stickyWrapper');
		const $stickyHeader = $('#stickyHeader');

		// there may be a case where sticky elements don't exist
		if ($stickyWrapper.length === 0) {

			return false;

		}

		globals.stickyWrapperHeight = $stickyHeader.outerHeight();

		// initialize sticky header
		$stickyWrapper
			.sticky({
				getWidthFrom: 'body',
				zIndex: 10,
				responsiveWidth: true
			})
			.on('sticky-start', function () {

				$(this).css('visibility', 'visible');

			})
			.on('sticky-end', function () {

				$(this).css('visibility', 'hidden');

			});

		if (backToTopBtn) {

			backToTopBtn.addEventListener('click', events.backToTop);

		}

	}

	return Object.freeze({ init });

}

export default initStickyHeader;
